import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { Attachment, IEmployeeEnrollment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";
import { useInvalidateCompanyEmployeeViews } from "./useGetCompanyEmployeeViews";
import { useInvalidateNeedsAttentionData } from "./useGetNeedsAttentionData";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  enrollments: IEmployeeEnrollment[];
};
const deleteEmployeeEnrollments = async ({
  countryCode,
  clientInternalNumberGOS,
  enrollments,
}: Params) => {
  const response = await api.patch(
    `/employeeenrollment/delete/${countryCode}/${clientInternalNumberGOS}`,
    [...enrollments]
  );
  return response.data as Attachment;
};

export function useDeleteEmployeeEnrollments(refetch = true) {
  const queryClient = useQueryClient();
  const invalidateCompanyEmployees = useInvalidateCompanyEmployeeViews();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateNeedsAttentionData = useInvalidateNeedsAttentionData();

  return useMutation(deleteEmployeeEnrollments, {
    mutationKey: MUTATION_KEYS.deleteEmployeeEnrollments,
    onSuccess: () => {
      if (refetch) {
        invalidateCompanyEmployees();

        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.companyEmployeeViews,
        });
        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.companyPackages,
        });
        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.companyAction,
        });
      }
      invalidateNeedsAttentionData();
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
